<template>
  <div class="preservice-detail">
    <v-card class="preservice-detail-card" flat>
      <v-card-text>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Full Name:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.firstName ? values.firstName : "-" }}
              {{ values.fatherName ? values.fatherName : "-" }}
              {{ values.grandFatherName ? values.grandFatherName : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Sex:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.sex ? values.sex : "-" }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Date of Birth:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.dateOfBirth ? values.dateOfBirth : "-" }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">National ID (FAN):</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.idNo ? formatFanId(values.idNo) : "-" }}
            </p>
          </div>
        </div>
      </v-card-text>

      <div class="preservice-detail-section-title title">
        About University
      </div>

      <v-card-text>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">
              Higher Learning Institution:
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ universityName }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Ownership:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ universityOwnership }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Generation Level:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ universityGeneration }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Region:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ universityRegion }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Town:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ universityTown }}
            </p>
          </div>
          <div class="w-1/2 h-12"></div>
          <div class="w-1/2 h-12"></div>
        </div>
      </v-card-text>

      <div class="preservice-detail-section-title title">
        Educational Information
      </div>

      <v-card-text>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Program Education Type:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ educationProgramName }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Department / Discipline:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ disciplineName }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Level Of Study:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ levelOfStudyName }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Year of Entry:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.entryYear ? values.entryYear : "-" }}
            </p>
          </div>
        </div>
        <div class="flex my-4 mb-4">
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">
              Expected Graduation Year:
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{
                values.expectedYear
                    ? values.expectedYear
                    : "-"
              }}
            </p>
          </div>
          <div class="w-1/2 h-12">
            <p class="text-md-left font-weight-bold">Year of Graduation:</p>
          </div>
          <div class="w-1/2 h-12">
            <p class="font-weight-medium">
              {{ values.graduationYear ? values.graduationYear : "-" }}
            </p>
          </div>
        </div>

        <v-card
            class="flex flex-wrap my-2 mb-6"
            outlined
            style="background-color: whitesmoke"
        >
          <div class="w-full pb-0 md:mb-0">
            <v-simple-table
                :light="dataTableLight"
                class="preservice-status-history-table"
            >
              <template
                  v-if="studentStatusRows.length === 0"
                  v-slot:no-data
              >
                NO DATA TO DISPLAY
              </template>
              <template v-else v-slot:default>
                <thead style="background-color: #e9ecee;">
                <tr>
                  <th width="5%">#</th>
                  <th class="text-left" width="10%">
                    Year of Education
                  </th>
                  <th class="text-left" width="10%">
                    Student Status
                  </th>
                  <th class="text-left" width="10%">
                    GPA
                  </th>
                  <th class="text-left" width="10%">
                    Cumulative GPA
                  </th>
                  <!-- <th width="10%" class="text-left">
                    Discipline
                  </th> -->
                </tr>
                </thead>
                <tbody style="background-color: whitesmoke;">
                <tr
                    v-for="(item, index) in studentStatusRows"
                    :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>
                    <span>{{ item.yearOfEducation || "-" }}</span>
                  </td>
                  <td>
                    <span>{{ item.studentStatus || "-" }}</span>
                  </td>
                  <td>
                    <span>{{ getDisplayGpa(item) }}</span>
                  </td>
                  <td>
                    <span>{{ getDisplayCumulativeGpa(item) }}</span>
                  </td>
                  <!-- <td>
                    <span>{{ item.discipline }}</span>
                  </td> -->
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {formatFanId} from "@/utils/fan-id";
import {getStudentStatusGpaItems} from "@/utils/studentStatusGpa";

const getDisplayValue = (value) => {
  if (value === "" || value == null) {
    return null;
  }

  if (typeof value === "object") {
    return value?.name || null;
  }

  return value;
};

export default {
  props: {
    graduates: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      values: {},
      dataTableLight: true,
    };
  },
  computed: {
    universityName() {
      return (
        getDisplayValue(this.values?.university) ||
        getDisplayValue(this.values?.higherLearningInstitution) ||
        "-"
      );
    },
    universityOwnership() {
      return (
        getDisplayValue(this.values?.university?.ownership) ||
        getDisplayValue(this.values?.universityOwner) ||
        getDisplayValue(this.values?.ownership) ||
        "-"
      );
    },
    universityGeneration() {
      return (
        getDisplayValue(this.values?.university?.generation) ||
        getDisplayValue(this.values?.generationLevel) ||
        "-"
      );
    },
    universityRegion() {
      return (
        getDisplayValue(this.values?.university?.region) ||
        getDisplayValue(this.values?.location) ||
        getDisplayValue(this.values?.region) ||
        "-"
      );
    },
    universityTown() {
      return (
        getDisplayValue(this.values?.university?.town) ||
        getDisplayValue(this.values?.town) ||
        "-"
      );
    },
    educationProgramName() {
      return getDisplayValue(this.values?.educationProgram) || "-";
    },
    disciplineName() {
      return getDisplayValue(this.values?.discipline) || "-";
    },
    levelOfStudyName() {
      return getDisplayValue(this.values?.levelOfStudy) || "-";
    },
    studentStatusRows() {
      return getStudentStatusGpaItems(this.values);
    },
  },
  created() {
    if (this.graduates != null) {
      this.values = this.graduates;
    }
  },
  methods: {
    formatFanId,
    getDisplayGpa(item) {
      return item?.gpa ?? "-";
    },
    getDisplayCumulativeGpa(item) {
      if (item?.cumulativeGpa != null) {
        return item.cumulativeGpa;
      }

      return "-";
    },
  },
};
</script>
